<template>
  <div class="home wrapper">
    <!-- Header -->
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-70 md-small-size-70 md-xsmall-size-100"
          >
            <vue-typed-js
              :strings="['webdeveloper']"
              :loop="true"
              @onComplete="doSmth()"
            >
              <div class="banner">
                <h3 class="title">Hello! My name is</h3>
                <br />
                <h2 class="name title">Nick van Bruggen</h2>
                <br />
                <h3 class="title">And I'm a <span class="typing"></span> !</h3>
              </div>
            </vue-typed-js>
            <br />
            <md-button href="#messageme" class="md-success md-lg home-button">
              <b>Message me! </b> <i class="fas fa-angle-right icon"></i
            ></md-button>
          </div>
        </div>
      </div>
    </parallax>
    <!-- About me -->
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">About me</h2>
              <h5 class="description">
                I make websites for fun so if you are interested. I can develop
                a website for you!
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>devices</md-icon>
                  </div>
                  <h4 class="info-title">Mobile Friendly</h4>
                  <p>
                    Your website will be responsive for any device. So you can
                    view your website nice and clean on any device!
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>verified_user</md-icon>
                  </div>
                  <h4 class="info-title">Any website</h4>
                  <p>
                    You want a simple website or even a webshop? I can do it
                    all!
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>chat</md-icon>
                  </div>
                  <h4 class="info-title">Free Chat</h4>
                  <p>
                    I will always be available for you to chat about your
                    wishes!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider">
        <i class="fas fa-angle-left"></i><i class="fas fa-circle"></i
        ><i class="fas fa-angle-right"></i>
      </div>

      <!-- The one man army -->
      <div class="section text-center">
        <div class="container">
          <h2 class="title">The One Man Army</h2>
          <div class="team">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg1"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Nick van Bruggen
                      <br />
                      <small class="card-description text-muted"
                        >Webdeveloper</small
                      >
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        I am 23 years old and in my spare time I like to build websites! I love to
                        play with the frontend of websites so HTML and CSS are my favorite languages!
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider">
        <i class="fas fa-angle-left"></i><i class="fas fa-circle"></i
        ><i class="fas fa-angle-right"></i>
      </div>

      <!-- Message me -->
      <div class="section section-contacts" id="messageme">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Send me a message!</h2>
              <h4 class="text-center description">
                Interested in a website? Just send me a message and I will
                respond very fast!
              </h4>
              <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button
                      class="md-success"
                      type="submit"
                      value="Send Message"
                      href="mailto:nickvbruggen0110@gmail.com"
                      >Send Message
                    </md-button>
                  </div>
                </div>

              <!-- <form class="contact-form" ref="form" @submit.prevent="sendEmail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Name</label>
                      <md-input
                        name="name"
                        v-model="name"
                        type="text"
                      ></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Email</label>
                      <md-input
                        name="email"
                        v-model="email"
                        type="email"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Your Message</label>
                  <md-textarea name="message" v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button
                      class="md-success"
                      type="submit"
                      value="Send Message"
                      >Send Message
                    </md-button>
                  </div>
                </div>

                 SUCCES ALLERT -->
                <!-- <div class="alert alert-success" v-if="type === 'result'">
                  <div class="container">
                    <button type="button" aria-hidden="true" class="close">
                      <i class="md-icon md-icon-font md-theme-default">clear</i>
                    </button>
                    <div class="alert-icon">
                      <i class="md-icon md-icon-font md-theme-default">check</i>
                    </div>
                    <b> SUCCESS! </b> : The e-mail has been sent!
                  </div>
                </div> -->
                <!-- ERROR ALERT -->
                <!-- <div class="alert alert-danger" v-if="type === 'error'">
                  <div class="container">
                    <button type="button" aria-hidden="true" class="close">
                      <i class="md-icon md-icon-font md-theme-default">clear</i>
                    </button>
                    <div class="alert-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >info_outline</i
                      >
                    </div>
                    <b> ERROR! </b> : There was an error and the e-mail has not
                    been sent. Please try again!
                  </div>
                </div> -->
              <!-- </form>  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg7.jpg"),
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/travel.jpg"),
    },
  },
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
  methods: {
    sendEmail() {
      emailjs
        .sendForm(
          "service_wmtnjf3",
          "template_gwo2jad",
          this.$refs.form,
          "q0TbKsgr7tSvvhnMA"
        )
        .then(
          result => {
            alert("The e-mail has been sent!");
          },
          error => {
            alert(
              "There was an error and the e-mail has not been sent. Pleas try again!"
            );
          }
        );
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
